import React, { useContext } from 'react'

import {
    Accordion,
    AccordionItem,
    AccordionItemBody,
    AccordionItemHeader,
    AccordionProvider,
    Link,
    Text,
} from '@vividseats/vivid-ui-kit'
import NextLink from 'next/link'

import licensesContext from '@/context/production-licenses'

import styles from './styles.module.scss'

const ResellerLicenses: React.FC = () => {
    const { selectors } = useContext(licensesContext)

    const items = selectors.licenses?.map(({ label, to }) => {
        return to ? (
            <Link LinkComponent={NextLink} className={styles.link} href={to} key={label}>
                <Text as="label" height="compressed" size="md" weight="regular">
                    {label}
                </Text>
            </Link>
        ) : (
            <Text as="label" height="compressed" size="md" weight="regular" key={label}>
                {label}
            </Text>
        )
    })

    return (
        <div className={styles.licenses}>
            <AccordionProvider>
                <Accordion>
                    <AccordionItem className={styles.accordionItem}>
                        <AccordionItemHeader>
                            <Text weight="bold">Reseller License Numbers</Text>
                        </AccordionItemHeader>
                        <AccordionItemBody className={styles.body}>{items}</AccordionItemBody>
                    </AccordionItem>
                </Accordion>
            </AccordionProvider>
        </div>
    )
}

export default ResellerLicenses
